import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head } from '@cinch-nx/landing-ui-shared'
import {
  ComponentLayouts,
  StoryblokRendererV2 as StoryblokRenderer,
} from '@cinch-nx/storyblok-utils'
import { CarCollectionsProps } from './get-static-props'
import { storyblokComponentsCollections } from './storyblok/data/storyblok-renderer-map'
import { CarCollectionsStory } from './storyblok/storyblok'

export const CarCollections = ({ story, preview }: CarCollectionsProps) => {
  const { content } = useStoryblokState<CarCollectionsStory>({
    story,
    enableBridge: preview,
  })

  const SEO = content.SEO?.[0] ?? {}

  const {
    SectionWithImageV2,
    FeatureCardRowWrapper,
    PreFooterCtaV2,
    ...remainingComponents
  } = storyblokComponentsCollections

  const componentLayouts: ComponentLayouts = {
    fullWidthWrapper: {
      SectionWithImageV2,
      FeatureCardRowWrapper,
      PreFooterCtaV2,
    },
    slimWrapper: remainingComponents,
  }

  return (
    <>
      <Head
        {...SEO}
        fallbackTitle="Collecting your car - cinch"
        fallbackDescription="Prefer to collect your new motor? Choose a time and place that suits you – locations across the country, open six days a week."
      />
      <article>
        <StoryblokRenderer block={content.body} components={componentLayouts} />
      </article>
    </>
  )
}
